import { createFileRoute } from '@tanstack/react-router'

import PageToolOutpaintMask from '../pages/PageToolOutpaintMask'

export const Route = createFileRoute('/tools/outpaint-mask')({
  component: PageToolOutpaintMask
})
